(() => {
  "use strict";
  const closeDetails = (details, restore = false) => {
    details.open = false;
    if (restore) details.querySelector("summary")?.focus();
  };
  const navs = [...document.querySelectorAll(".nav-dropdown")];
  navs.forEach((details) => {
    details.addEventListener("toggle", () => {
      if (details.open)
        navs
          .filter((other) => other !== details)
          .forEach((other) => closeDetails(other));
    });
  });
  const mobileMenu = document.querySelector(".mobile-menu");
  const headerShell = document.querySelector("[data-header-shell]");
  const siteHeader = headerShell?.querySelector(".site-header");
  const mobileHeaderQuery = matchMedia("(max-width: 700px)");
  let headerFrame = 0;
  const syncHeader = () => {
    headerFrame = 0;
    if (!headerShell || !siteHeader) return;
    if (!mobileHeaderQuery.matches) {
      headerShell.classList.remove("header-is-compact");
      headerShell.style.removeProperty("--expanded-header-height");
      return;
    }
    if (!headerShell.classList.contains("header-is-compact")) {
      headerShell.style.setProperty("--expanded-header-height", `${siteHeader.offsetHeight}px`);
    }
    if (mobileMenu?.open) return;
    headerShell.classList.toggle("header-is-compact", window.scrollY >= 50);
  };
  const queueHeader = () => {
    if (!headerFrame) headerFrame = requestAnimationFrame(syncHeader);
  };
  window.addEventListener("scroll", queueHeader, { passive: true });
  window.addEventListener("resize", queueHeader, { passive: true });
  window.addEventListener("pageshow", queueHeader);
  mobileHeaderQuery.addEventListener("change", queueHeader);
  mobileMenu?.addEventListener("toggle", queueHeader);
  syncHeader();
  const franchiseMenu = mobileMenu?.querySelector("[data-franchise-menu]");
  const menuPanel = mobileMenu?.querySelector(".mobile-menu-panel");
  const closeFranchises = (restoreFocus = false) => {
    if (!franchiseMenu) return;
    closeDetails(franchiseMenu, restoreFocus);
    if (menuPanel) menuPanel.scrollTop = 0;
  };
  franchiseMenu?.addEventListener("toggle", () => {
    if (franchiseMenu.open) {
      menuPanel.scrollTop = 0;
      franchiseMenu.querySelector("[data-menu-back]")?.focus({ preventScroll: true });
    }
  });
  mobileMenu?.querySelector("[data-menu-back]")?.addEventListener("click", () => closeFranchises(true));
  mobileMenu?.addEventListener("toggle", () => {
    document.body.classList.toggle("menu-open", mobileMenu.open);
    if (!mobileMenu.open) closeFranchises();
    if (mobileMenu.open) mobileMenu.querySelector("[data-close-menu]")?.focus();
  });
  document
    .querySelector("[data-close-menu]")
    ?.addEventListener("click", () => closeDetails(mobileMenu, true));
  document.addEventListener("click", (event) => {
    navs
      .filter((d) => d.open && !d.contains(event.target))
      .forEach((d) => closeDetails(d));
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      navs.filter((d) => d.open).forEach((d) => closeDetails(d, true));
      if (mobileMenu?.open) {
        if (franchiseMenu?.open) closeFranchises(true);
        else closeDetails(mobileMenu, true);
      }
    }
    if (event.key === "Tab" && mobileMenu?.open) {
      const focusables = [
        ...menuPanel.querySelectorAll("a, button, summary, input:not([type=hidden])"),
      ].filter((el) => el.getClientRects().length);
      const first = focusables[0],
        last = focusables.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
  matchMedia("(min-width: 701px)").addEventListener("change", (event) => {
    if (event.matches && mobileMenu?.open) closeDetails(mobileMenu);
  });
  document.querySelectorAll("[data-shelf]").forEach((shelf) => {
    const track = shelf.querySelector("[data-product-track]");
    const prev = shelf.querySelector("[data-shelf-prev]"),
      next = shelf.querySelector("[data-shelf-next]");
    const update = () => {
      prev.disabled = track.scrollLeft < 2;
      next.disabled =
        track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const slide = (direction) =>
      track.scrollBy({
        left: direction * track.clientWidth * 0.86,
        behavior: matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "instant"
          : "smooth",
      });
    prev.addEventListener("click", () => slide(-1));
    next.addEventListener("click", () => slide(1));
    track.addEventListener("scroll", update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  });
  const notice = document.querySelector(".cart-notice");
  const announceAdded = () => {
    if (!notice) return;
    notice.replaceChildren(document.createTextNode("Agregado a tu carrito."));
    const link = document.createElement("a");
    link.href = document.body.dataset.cartUrl;
    link.textContent = "Ver carrito";
    const close = document.createElement("button");
    close.type = "button";
    close.textContent = "×";
    close.setAttribute("aria-label", "Cerrar aviso");
    close.addEventListener("click", () => {
      notice.hidden = true;
    });
    notice.append(link, close);
    notice.hidden = false;
  };
  document.querySelectorAll("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (window.SpaceCart) {
        window.SpaceCart.add(form);
        return;
      }
      const button = form.querySelector('button[type="submit"]');
      const error = form.querySelector(".form-error");
      if (button.disabled) return;
      const original = button.innerHTML;
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.textContent = "Agregando…";
      error.hidden = true;
      try {
        const response = await fetch(`${document.body.dataset.cartAdd}.js`, {
          method: "POST",
          body: new FormData(form),
          headers: { Accept: "application/json" },
        });
        const result = await response.json();
        if (!response.ok)
          throw new Error(
            result.description ||
              result.message ||
              "No pudimos agregar este producto. Inténtalo de nuevo.",
          );
        announceAdded();
        // A failed count refresh must not report the successful add as a failure.
        try {
          const cartResponse = await fetch(
            `${document.body.dataset.cartUrl}.js`,
            { headers: { Accept: "application/json" }, cache: "no-store" },
          );
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll("[data-cart-count]").forEach((el) => {
              el.textContent = cart.item_count;
            });
          }
        } catch (_) {
          /* The cart page remains authoritative. */
        }
      } catch (err) {
        error.textContent =
          err.message ||
          "No pudimos conectar. Revisa tu conexión e inténtalo de nuevo.";
        error.hidden = false;
      } finally {
        button.innerHTML = original;
        button.removeAttribute("aria-busy");
        const selected = form.querySelector("[data-variant-select]")
          ?.selectedOptions[0];
        button.disabled = selected
          ? selected.dataset.available !== "true"
          : false;
        form.dispatchEvent(new CustomEvent("product:idle"));
      }
    });
  });
  const variantSelect = document.querySelector("[data-variant-select]");
  if (!variantSelect?.closest("[data-product-detail-form]")) variantSelect?.addEventListener("change", () => {
    const option = variantSelect.selectedOptions[0];
    document.querySelector("[data-product-price]").textContent =
      option.dataset.price;
    const compare = document.querySelector("[data-product-compare]");
    compare.textContent = option.dataset.compare || "";
    compare.hidden = !option.dataset.compare;
    const button = variantSelect
      .closest("form")
      .querySelector('button[type="submit"]');
    button.disabled = option.dataset.available !== "true";
    button.textContent = button.disabled ? "Agotado" : "Agregar al carrito";
    const url = new URL(location.href);
    url.searchParams.set("variant", option.value);
    history.replaceState({}, "", url);
  });
  document.querySelectorAll("[data-gallery-image]").forEach((button) => {
    button.addEventListener("click", () => {
      const main = document.querySelector(".product-gallery-main");
      main.src = button.dataset.galleryImage;
      main.removeAttribute("srcset");
      main.alt = button.querySelector("img").alt;
      document
        .querySelectorAll("[data-gallery-image]")
        .forEach((other) =>
          other.setAttribute("aria-pressed", String(other === button)),
        );
    });
  });
})();
